import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
// import * as Sentry from '@sentry/angular';
// import { Integrations } from '@sentry/tracing';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
/*
if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [environment.frontUrl.replace('/#', ''), environment.apiUrl + '/api'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: 1.0,
  });
  Sentry.setTag('section', 'frontend');
}
*/

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
